import apiClient from '../axios.js';

export const followMarketingCampaignService = {
  getCampaigns: async (params = {}) => {
    const response = await apiClient.get('/marketing/follow-campaigns', { params });
    return response;
  },

  getCampaign: async (id) => {
    const response = await apiClient.get(`/marketing/follow-campaigns/${id}`);
    return response;
  },

  createCampaign: async (payload) => {
    const response = await apiClient.post('/marketing/follow-campaigns', payload);
    return response;
  },

  updateCampaign: async (id, payload) => {
    const response = await apiClient.put(`/marketing/follow-campaigns/${id}`, payload);
    return response;
  },

  deleteCampaign: async (id) => {
    const response = await apiClient.delete(`/marketing/follow-campaigns/${id}`);
    return response;
  },

  getLogs: async (id, params = {}) => {
    const response = await apiClient.get(`/marketing/follow-campaigns/${id}/logs`, { params });
    return response;
  }
};
